/** @jsx h */
import { component, h } from 'literaljs';

const SkeletonLoader = component({
	name: 'SkeletonLoader',
	props: ['type'],
	render() {
		const { type } = this.props;
		
		if (type === 'kanban') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -text-md -w-60" />
						<div class="demo-skeleton-block -text-md -w-20" />
					</div>
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -h-80 -w-30" />
						<div class="demo-skeleton-block -h-80 -w-30" />
						<div class="demo-skeleton-block -h-80 -w-30" />
					</div>
				</div>
			);
		}
		
		if (type === 'search') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-block -h-32 -w-100" />
					<div class="demo-skeleton-row" style={{ marginTop: '0.5rem' }}>
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-40" />
						<div class="demo-skeleton-block -text-sm -w-30" />
					</div>
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-50" />
						<div class="demo-skeleton-block -text-sm -w-20" />
					</div>
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-40" />
						<div class="demo-skeleton-block -text-sm -w-30" />
					</div>
				</div>
			);
		}
		
		if (type === 'clock') {
			return (
				<div class="demo-skeleton" style={{ alignItems: 'center' }}>
					<div class="demo-skeleton-block -circle" style={{ width: '160px', height: '160px' }} />
					<div class="demo-skeleton-block -text-md -w-30" style={{ marginTop: '0.5rem' }} />
					<div class="demo-skeleton-row" style={{ marginTop: '0.25rem' }}>
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-20" />
					</div>
				</div>
			);
		}
		
		if (type === 'pomodoro') {
			return (
				<div class="demo-skeleton" style={{ alignItems: 'center' }}>
					<div class="demo-skeleton-block -circle" style={{ width: '140px', height: '140px' }} />
					<div class="demo-skeleton-block -text-md -w-30" style={{ marginTop: '0.5rem' }} />
					<div class="demo-skeleton-row" style={{ marginTop: '0.5rem' }}>
						<div class="demo-skeleton-block -h-32 -w-30" />
						<div class="demo-skeleton-block -h-32 -w-30" />
					</div>
					<div class="demo-skeleton-row" style={{ marginTop: '0.25rem' }}>
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-20" />
						<div class="demo-skeleton-block -text-sm -w-20" />
					</div>
				</div>
			);
		}
		
		if (type === 'expense') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-block -h-48 -w-40" style={{ margin: '0 auto' }} />
					<div class="demo-skeleton-block -h-24 -w-100" style={{ marginTop: '0.75rem' }} />
					<div class="demo-skeleton-block -h-24 -w-100" style={{ marginTop: '0.375rem' }} />
					<div class="demo-skeleton-block -h-24 -w-100" style={{ marginTop: '0.375rem' }} />
					<div class="demo-skeleton-block -h-24 -w-100" style={{ marginTop: '0.375rem' }} />
					<div class="demo-skeleton-row" style={{ marginTop: '0.75rem' }}>
						<div class="demo-skeleton-block -h-32 -w-60" />
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
					</div>
				</div>
			);
		}
		
		if (type === 'palette') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-block -h-32 -w-40" style={{ margin: '0 auto' }} />
					<div class="demo-skeleton-row" style={{ marginTop: '0.75rem' }}>
						<div class="demo-skeleton-block -h-64 -w-20" />
						<div class="demo-skeleton-block -h-64 -w-20" />
						<div class="demo-skeleton-block -h-64 -w-20" />
						<div class="demo-skeleton-block -h-64 -w-20" />
						<div class="demo-skeleton-block -h-64 -w-20" />
					</div>
					<div class="demo-skeleton-block -text-sm -w-60" style={{ margin: '0.5rem auto 0' }} />
				</div>
			);
		}
		
		if (type === 'markdown') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -h-24 -w-20" />
						<div class="demo-skeleton-block -h-24 -w-20" />
						<div class="demo-skeleton-block -h-24 -w-20" />
					</div>
					<div class="demo-skeleton-row" style={{ marginTop: '0.5rem' }}>
						<div class="demo-skeleton-block -h-120 -w-50" />
						<div class="demo-skeleton-block -h-120 -w-50" />
					</div>
				</div>
			);
		}
		
		if (type === 'password') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-block -h-40 -w-100" />
					<div class="demo-skeleton-block -h-16 -w-100" style={{ marginTop: '0.5rem' }} />
					<div class="demo-skeleton-block -h-24 -w-100" style={{ marginTop: '0.75rem' }} />
					<div class="demo-skeleton-row" style={{ marginTop: '0.5rem' }}>
						<div class="demo-skeleton-block -h-32 -w-50" />
						<div class="demo-skeleton-block -h-32 -w-50" />
					</div>
					<div class="demo-skeleton-block -h-32 -w-40" style={{ margin: '0.75rem auto 0' }} />
				</div>
			);
		}
		
		if (type === 'typing') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-row" style={{ justifyContent: 'center' }}>
						<div class="demo-skeleton-block -h-48 -w-20" />
						<div class="demo-skeleton-block -h-48 -w-20" />
						<div class="demo-skeleton-block -h-48 -w-20" />
					</div>
					<div class="demo-skeleton-block -h-64 -w-100" style={{ marginTop: '0.75rem' }} />
					<div class="demo-skeleton-block -h-40 -w-50" style={{ margin: '0.75rem auto 0' }} />
				</div>
			);
		}

		if (type === 'weather') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-block -h-160 -w-100" style={{ borderRadius: '16px' }} />
					<div class="demo-skeleton-row" style={{ marginTop: '0.75rem', justifyContent: 'center' }}>
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
					</div>
				</div>
			);
		}

		if (type === 'chart') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-row" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
					</div>
					<div class="demo-skeleton-row" style={{ alignItems: 'flex-end', height: '120px' }}>
						<div class="demo-skeleton-block -w-100" style={{ height: '60%' }} />
						<div class="demo-skeleton-block -w-100" style={{ height: '80%' }} />
						<div class="demo-skeleton-block -w-100" style={{ height: '45%' }} />
						<div class="demo-skeleton-block -w-100" style={{ height: '95%' }} />
						<div class="demo-skeleton-block -w-100" style={{ height: '70%' }} />
						<div class="demo-skeleton-block -w-100" style={{ height: '55%' }} />
					</div>
					<div class="demo-skeleton-block -text-sm -w-40" style={{ margin: '0.5rem auto 0' }} />
				</div>
			);
		}

		if (type === 'gallery') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-row" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
						<div class="demo-skeleton-block -h-32 -w-20" />
					</div>
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -h-120 -w-30" />
						<div class="demo-skeleton-block -h-120 -w-30" />
						<div class="demo-skeleton-block -h-120 -w-30" />
					</div>
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -h-120 -w-30" />
						<div class="demo-skeleton-block -h-120 -w-30" />
						<div class="demo-skeleton-block -h-120 -w-30" />
					</div>
				</div>
			);
		}

		if (type === 'chat') {
			return (
				<div class="demo-skeleton">
					<div class="demo-skeleton-block -h-180 -w-100" style={{ borderRadius: '12px', marginBottom: '0.75rem' }} />
					<div class="demo-skeleton-row">
						<div class="demo-skeleton-block -h-40 -w-80" />
						<div class="demo-skeleton-block -h-40 -w-20" />
					</div>
				</div>
			);
		}

		return (
			<div class="demo-skeleton">
				<div class="demo-skeleton-block -h-32 -w-100" />
				<div class="demo-skeleton-block -h-32 -w-80" style={{ marginTop: '0.5rem' }} />
				<div class="demo-skeleton-block -h-32 -w-60" style={{ marginTop: '0.5rem' }} />
			</div>
		);
	}
});

export default SkeletonLoader;
